<script>
import { RouterLink } from 'vue-router'

const activeClass = 'tab-active'

export default {
  name: 'TabLink',
  inheritAttrs: false,

  props: {
    // add @ts-ignore if using TypeScript
    ...RouterLink.props,
    inactiveClass: String,
  },
}
</script>

<template>
  <RouterLink
    v-bind="$props"
    custom
    v-slot="{ isActive, href, navigate }"
  >
    <a
      v-bind="$attrs"
      :href="href"
      @click="navigate"
      :class="`tab ${isActive ? activeClass : ''}`"
    >
      <slot />
    </a>
  </RouterLink>
</template>